
<v-app v-if="!init" class="py-2">
  <v-content style="margin-left: 35px; margin-right: 35px;">
    <Header class="mb-5"/>
    <CardView v-if="cardView"/>
    <ListView v-else/>
    <div class="">
      <TablePagination 
        ref="tablePagination"
        @loadData="loadData" 
        @loadPerPage="loadPerPage"
        :perPage="pageSize"
        :totalItems="totalData"
        showDropdownPerPage
        title="document(s)"
      />
    </div>
    <Lightbox/>
    <Snackbar/>
  </v-content>
</v-app>
